import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { meta } from 'helpers/decorators'
import { SuccessBadges } from '../../../../components/misc'

@meta({
  title: 'Registration Complete',
  intlKey: 'pageTitle.registration_complete'
})
class AwardUnitSuccess extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <h1 className="beta">
            <span
              className="ico ico--checked"
              style={{ position: 'relative', top: 5, paddingRight: 15 }}
            />
            <FormattedMessage
              id="moduleTitle.your_registration_is_complete"
              defaultMessage="Your registration is complete"
            />
          </h1>
          <p className="desc">
            <FormattedMessage
              id="label.we_will_send_you_an_email_leader"
              defaultMessage="We will send you an email when your registration has been approved. You will then be able to log into the Online Record Book."
            />
          </p>
          <p className="desc">
            <FormattedMessage
              id="label.if_you_have_questions_au"
              defaultMessage="If you have any questions about your registration, please contact your Award Unit."
            />
          </p>
          <SuccessBadges isAwardStaff={true} />
        </div>
      </div>
    )
  }
}

export default AwardUnitSuccess
